import { useEffect } from "react";
import { Layout } from "../components/Layout";
import { CHANGELOG, LATEST_VERSION, SEEN_KEY } from "../data/changelog";
import { Sparkle, Plus, ArrowUp, Wrench } from "@phosphor-icons/react";

const TAG = {
  new: { label: "New", color: "#00FF41", Icon: Plus },
  improved: { label: "Improved", color: "#00F0FF", Icon: ArrowUp },
  fixed: { label: "Fixed", color: "#FEBC2E", Icon: Wrench },
};

export default function WhatsNew() {
  useEffect(() => {
    localStorage.setItem(SEEN_KEY, LATEST_VERSION);
    window.dispatchEvent(new Event("whatsnew-seen"));
  }, []);

  return (
    <Layout>
      <div className="border-b border-[#27272A] px-8 py-6">
        <h1 className="text-2xl tracking-tight flex items-center gap-2">
          <Sparkle size={22} weight="fill" className="text-[#00F0FF]" /> What's New
        </h1>
        <p className="text-sm text-[#A1A1AA] font-mono mt-1">
          Every release, patch and fix in MDM Forge — newest first.
        </p>
      </div>

      <div className="max-w-3xl p-8" data-testid="whatsnew-list">
        <div className="relative border-l border-[#27272A] ml-2 pl-8 space-y-12">
          {CHANGELOG.map((rel, i) => (
            <div key={rel.version} data-testid={`whatsnew-release-${rel.version}`} className="relative">
              <span className="absolute -left-[41px] top-1 w-3 h-3 border-2 border-[#00F0FF] bg-[#0A0A0B]" />
              <div className="flex flex-wrap items-center gap-3 mb-1">
                <span className="font-mono text-sm text-[#00F0FF]">v{rel.version}</span>
                {i === 0 && (
                  <span className="font-mono text-[9px] uppercase tracking-wider text-[#00FF41] border border-[#00FF41]/40 px-2 py-0.5">
                    Latest
                  </span>
                )}
                <span className="font-mono text-[11px] text-[#71717A]">{rel.date}</span>
              </div>
              <h2 className="text-lg tracking-tight text-[#FAFAFA] mb-4">{rel.title}</h2>
              <ul className="space-y-2.5">
                {rel.changes.map((c, j) => {
                  const t = TAG[c.type] || TAG.improved;
                  return (
                    <li key={j} className="flex items-start gap-3">
                      <span
                        className="mt-0.5 shrink-0 inline-flex items-center gap-1 font-mono text-[9px] uppercase tracking-wider px-1.5 py-0.5 border"
                        style={{ color: t.color, borderColor: t.color + "55", background: t.color + "12" }}
                      >
                        <t.Icon size={10} weight="bold" /> {t.label}
                      </span>
                      <span className="text-[13px] text-[#C7C7CC] leading-relaxed">{c.text}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
